<div class="text-white font-medium text-sm md:hidden mt-[75px]">
  <div
    class="bg-[var(--color-primary)] flex text-base flex-col justify-center items-center text-center py-4"
  >
    <div
      class="w-auto h-auto py-2 flex items-start cursor-pointer"
      (click)="goUbicacion()"
      (keydown.enter)="goUbicacion()"
      (keydown.space)="goUbicacion()"
      role="link"
      tabindex="0"
    >
      <!-- Columna del SVG -->
      <div class="h-full">
        <div>
          <svg
            width="46"
            height="42"
            viewBox="0 0 46 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.7275 15.2279L36.0042 3.68976C36.2997 3.14179 36.1031 2.43608 35.5325 2.14193L31.8337 0.163566C31.2833 -0.13058 30.5745 0.0651224 30.2791 0.614274L25.1436 10.0364C24.4944 11.2308 24.6123 12.5046 25.0054 13.5235C25.2413 14.1509 24.4741 14.6597 23.9631 14.2292C22.9791 13.4262 22.1333 12.3872 21.6414 11.487L15.7185 0.595297C15.4231 0.0473313 14.7155 -0.168534 14.1639 0.144589L10.4651 2.14312C9.91473 2.43727 9.69792 3.14179 10.0124 3.69095L16.2891 15.2291C16.9181 16.3843 18.1188 17.09 19.4376 17.09H26.5993C27.8978 17.1102 29.0986 16.3843 29.7275 15.2291"
              fill="white"
            />
            <path
              d="M24.9851 30.2732L31.8907 41.459C32.2255 41.988 32.9331 42.1647 33.4644 41.8314L37.0453 39.6372C37.5766 39.3039 37.7541 38.5994 37.4193 38.0704L31.7728 28.9424C31.064 27.7872 29.9037 27.2582 28.8018 27.0613C28.1324 26.9439 28.074 26.0235 28.703 25.7874C29.9026 25.3367 31.2213 25.1209 32.2636 25.16L44.6978 25.4933C45.328 25.5135 45.8581 25.0236 45.8784 24.3772L45.9963 20.1856C46.0166 19.5582 45.5246 19.0304 44.8753 19.0102L31.7133 18.658C30.3945 18.6188 29.1747 19.3044 28.5255 20.4406L24.9446 26.6307C24.2954 27.767 24.3144 29.1583 24.9839 30.2744"
              fill="white"
            />
            <path
              d="M14.2831 18.6758L1.12096 19.0281C0.490794 19.047 0 19.576 0 20.2035L0.117933 24.395C0.138185 25.0225 0.668289 25.5313 1.29846 25.5111L12.0602 25.217C13.4182 25.1779 14.4605 24.4532 15.1693 23.5909C15.6018 23.0821 16.4285 23.4735 16.3106 24.1389C16.0937 25.3925 15.622 26.6462 15.0907 27.5275L8.57817 38.0669C8.24343 38.5959 8.42093 39.3004 8.95222 39.6337L12.5331 41.8279C13.0644 42.1612 13.7732 41.9845 14.1067 41.4555L21.0124 30.2697C21.7009 29.1536 21.7212 27.7623 21.072 26.626L17.472 20.4549C16.8228 19.3187 15.603 18.6331 14.2842 18.6722"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <!-- Columna del texto -->
      <div class="pl-4 text-left">
        <p><span [innerHTML]="site.contact.address_mobile"></span></p>

        @if (site.footer.mobile.phone) {
          <p>{{ site.footer.mobile.phone }}</p>
        }
        <div class="w-full h-[1px] bg-white my-4"></div>

        <p><span [innerHTML]="site.footer.mobile.administrativeHours"></span></p>

        <div class="w-full h-[1px] bg-white my-4"></div>
        <p><span [innerHTML]="site.footer.mobile.emergencyText"></span></p>
      </div>
    </div>
  </div>

  <!-- Sección gris inferior -->
  <div
    class="bg-[var(--color-text-medium)] px-6 py-4 text-center text-white font-medium text-base font-thin"
  >
    <strong>Estás</strong> en la
    <span class="bg-[var(--color-danger-dark)] text-white font-medium mx-2 px-2 py-1">
      RED AMR
    </span>
  </div>
  <div class="bg-[var(--color-text-medium)] border-t border-white/10 pb-4">
    <div
      class="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 px-4"
    >
      <button
        type="button"
        class="group flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-all duration-200"
        (click)="openTermsAndConditions()"
      >
        <span class="underline underline-offset-4 decoration-white/40 group-hover:decoration-white">
          Términos y Condiciones
        </span>
      </button>

      <div class="hidden sm:block h-4 w-px bg-white/20"></div>

      <button
        type="button"
        class="group flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-all duration-200"
        (click)="openPrivacyPolicy()"
      >
        <span class="underline underline-offset-4 decoration-white/40 group-hover:decoration-white">
          Políticas de Privacidad
        </span>
      </button>
    </div>
  </div>
</div>

<footer class="text-white font-medium text-sm max-md:hidden mt-[75px]">
  <!-- Parte superior azul -->
  <div
    class="bg-[var(--color-primary)] py-2 px-1 sm:py-8 sm:px-4 lg:px-12 grid grid-cols-2 sm:grid-cols-4 space-y-4 sm:space-y-0 text-left"
  >
    <!-- Nuestros Medios -->
    <div class="space-y-3 order-1 sm:space-x-3">
      <h3 class="font-medium text-sm sm:text-lg tracking-wide">Nuestros Medios</h3>
      <div class="flex justify-start lg:justify-start gap-1">
        <!-- redes -->
        <a
          [href]="site.social.facebook"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          class="bg-white p-2 rounded"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_193_187)">
              <path
                d="M17.6246 9.00027C17.6246 4.23723 13.7633 0.375977 9.00027 0.375977C4.23723 0.375977 0.375977 4.23723 0.375977 9.00027C0.375977 13.3049 3.52977 16.8728 7.65272 17.5198V11.4932H5.46296V9.00027H7.65272V7.10023C7.65272 4.93877 8.9403 3.74484 10.9103 3.74484C11.8538 3.74484 12.8408 3.91328 12.8408 3.91328V6.03567H11.7533C10.6819 6.03567 10.3478 6.70048 10.3478 7.38254V9.00027H12.7397L12.3573 11.4932H10.3478V17.5198C14.4708 16.8728 17.6246 13.3049 17.6246 9.00027Z"
                fill="var(--color-primary)"
              />
              <path
                d="M12.3573 11.4933L12.7396 9.0003H10.3477V7.38257C10.3477 6.70044 10.6819 6.0357 11.7532 6.0357H12.8407V3.91332C12.8407 3.91332 11.8538 3.74487 10.9101 3.74487C8.94023 3.74487 7.65265 4.9388 7.65265 7.10026V9.0003H5.46289V11.4933H7.65265V17.5198C8.09843 17.5897 8.54898 17.6247 9.0002 17.6246C9.45142 17.6247 9.90196 17.5897 10.3477 17.5198V11.4933H12.3573Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_193_187">
                <rect
                  width="17.2486"
                  height="17.2486"
                  fill="white"
                  transform="translate(0.375977 0.375977)"
                />
              </clipPath>
            </defs>
          </svg>
        </a>
        <a
          [href]="site.social.instagram"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          class="bg-white p-2 rounded"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.98188 1.81348H12.0189C14.3187 1.81348 16.1873 3.68207 16.1873 5.98188V12.0189C16.1873 13.1244 15.7481 14.1847 14.9664 14.9664C14.1847 15.7481 13.1244 16.1873 12.0189 16.1873H5.98188C3.68207 16.1873 1.81348 14.3187 1.81348 12.0189V5.98188C1.81348 4.87635 2.25265 3.8161 3.03437 3.03437C3.8161 2.25265 4.87635 1.81348 5.98188 1.81348ZM5.83815 3.25086C5.15195 3.25086 4.49387 3.52345 4.00866 4.00866C3.52345 4.49387 3.25086 5.15195 3.25086 5.83815V12.1626C3.25086 13.5928 4.40795 14.7499 5.83815 14.7499H12.1626C12.8488 14.7499 13.5069 14.4773 13.9921 13.9921C14.4773 13.5069 14.7499 12.8488 14.7499 12.1626V5.83815C14.7499 4.40795 13.5928 3.25086 12.1626 3.25086H5.83815ZM12.7735 4.32889C13.0118 4.32889 13.2403 4.42354 13.4088 4.59202C13.5772 4.7605 13.6719 4.989 13.6719 5.22726C13.6719 5.46552 13.5772 5.69402 13.4088 5.8625C13.2403 6.03097 13.0118 6.12562 12.7735 6.12562C12.5353 6.12562 12.3067 6.03097 12.1383 5.8625C11.9698 5.69402 11.8751 5.46552 11.8751 5.22726C11.8751 4.989 11.9698 4.7605 12.1383 4.59202C12.3067 4.42354 12.5353 4.32889 12.7735 4.32889ZM9.00039 5.40693C9.95343 5.40693 10.8674 5.78553 11.5413 6.45943C12.2152 7.13333 12.5938 8.04734 12.5938 9.00039C12.5938 9.95343 12.2152 10.8674 11.5413 11.5413C10.8674 12.2152 9.95343 12.5938 9.00039 12.5938C8.04734 12.5938 7.13333 12.2152 6.45943 11.5413C5.78553 10.8674 5.40693 9.95343 5.40693 9.00039C5.40693 8.04734 5.78553 7.13333 6.45943 6.45943C7.13333 5.78553 8.04734 5.40693 9.00039 5.40693ZM9.00039 6.84431C8.42856 6.84431 7.88015 7.07147 7.47581 7.47581C7.07147 7.88015 6.84431 8.42856 6.84431 9.00039C6.84431 9.57221 7.07147 10.1206 7.47581 10.525C7.88015 10.9293 8.42856 11.1565 9.00039 11.1565C9.57221 11.1565 10.1206 10.9293 10.525 10.525C10.9293 10.1206 11.1565 9.57221 11.1565 9.00039C11.1565 8.42856 10.9293 7.88015 10.525 7.47581C10.1206 7.07147 9.57221 6.84431 9.00039 6.84431Z"
              fill="var(--color-primary)"
            />
          </svg>
        </a>
        <a
          [href]="site.social.youtube"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
          class="bg-white p-2 rounded"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.563 11.1564L11.293 9.00032L7.563 6.84425V11.1564ZM15.8711 5.52904C15.9645 5.86683 16.0292 6.3196 16.0723 6.89455C16.1226 7.46951 16.1442 7.9654 16.1442 8.39662L16.1873 9.00032C16.1873 10.5743 16.0723 11.7313 15.8711 12.4716C15.6914 13.1184 15.2746 13.5353 14.6277 13.7149C14.29 13.8084 13.6719 13.873 12.7232 13.9162C11.7889 13.9665 10.9337 13.988 10.1431 13.988L9.00039 14.0312C5.98907 14.0312 4.11329 13.9162 3.37304 13.7149C2.72621 13.5353 2.30937 13.1184 2.1297 12.4716C2.03627 12.1338 1.97159 11.681 1.92847 11.1061C1.87816 10.5311 1.8566 10.0352 1.8566 9.60402L1.81348 9.00032C1.81348 7.42639 1.92847 6.26929 2.1297 5.52904C2.30937 4.88222 2.72621 4.46538 3.37304 4.28571C3.71082 4.19228 4.32889 4.12759 5.27757 4.08447C6.21186 4.03416 7.06711 4.0126 7.85767 4.0126L9.00039 3.96948C12.0117 3.96948 13.8875 4.08447 14.6277 4.28571C15.2746 4.46538 15.6914 4.88222 15.8711 5.52904Z"
              fill="var(--color-primary)"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- Dirección -->
    <div class="space-y-3 order-3 sm:order-2">
      <h3 class="font-medium text-sm sm:text-lg">Dirección</h3>
      <div
        class="flex justify-start lg:justify-start items-start space-x-0 sm:space-x-3 hover:cursor-pointer"
        (click)="goUbicacion()"
      >
        <svg width="20" height="20" fill="white" class="flex-shrink-0 mt-[2px]">
          <path
            d="M8 2.00002C6.76232 2.00002 5.57534 2.49168 4.70017 3.36685C3.825 4.24202 3.33333 5.42901 3.33333 6.66668C3.33333 8.57468 4.52133 10.4153 5.82533 11.8413C6.49209 12.5678 7.21962 13.236 8 13.8387C8.11644 13.7493 8.25311 13.6405 8.41 13.512C9.03654 12.9975 9.62621 12.4397 10.1747 11.8427C11.4787 10.4153 12.6667 8.57535 12.6667 6.66668C12.6667 5.42901 12.175 4.24202 11.2998 3.36685C10.4247 2.49168 9.23768 2.00002 8 2.00002ZM8 15.476L7.622 15.216L7.62 15.2147L7.616 15.2113L7.60267 15.202L7.55267 15.1667L7.37267 15.0353C6.46057 14.3499 5.61325 13.5822 4.84133 12.742C3.47867 11.25 2 9.09068 2 6.66602C2 5.07472 2.63214 3.54859 3.75736 2.42338C4.88258 1.29816 6.4087 0.666016 8 0.666016C9.5913 0.666016 11.1174 1.29816 12.2426 2.42338C13.3679 3.54859 14 5.07472 14 6.66602C14 9.09068 12.5213 11.2507 11.1587 12.7407C10.387 13.5809 9.53986 14.3485 8.628 15.034C8.55204 15.0908 8.47536 15.1465 8.398 15.2013L8.384 15.2107L8.38 15.214L8.37867 15.2147L8 15.476ZM8 5.33335C7.64638 5.33335 7.30724 5.47382 7.05719 5.72387C6.80714 5.97392 6.66667 6.31306 6.66667 6.66668C6.66667 7.0203 6.80714 7.35944 7.05719 7.60949C7.30724 7.85954 7.64638 8.00002 8 8.00002C8.35362 8.00002 8.69276 7.85954 8.94281 7.60949C9.19286 7.35944 9.33333 7.0203 9.33333 6.66668C9.33333 6.31306 9.19286 5.97392 8.94281 5.72387C8.69276 5.47382 8.35362 5.33335 8 5.33335ZM5.33333 6.66668C5.33333 5.95944 5.61428 5.28116 6.11438 4.78106C6.61448 4.28097 7.29276 4.00002 8 4.00002C8.70724 4.00002 9.38552 4.28097 9.88562 4.78106C10.3857 5.28116 10.6667 5.95944 10.6667 6.66668C10.6667 7.37393 10.3857 8.0522 9.88562 8.5523C9.38552 9.0524 8.70724 9.33335 8 9.33335C7.29276 9.33335 6.61448 9.0524 6.11438 8.5523C5.61428 8.0522 5.33333 7.37393 5.33333 6.66668Z"
            fill="white"
          />
        </svg>
        <p class="text-white font-medium text-sm sm:text-base">
          <span [innerHTML]="site.contact.address"></span>
        </p>
      </div>
    </div>

    <!-- Horario Administrativo -->
    <div class="space-y-3 order-2 sm:order-3 sm:mr-4">
      <h3 class="font-medium text-sm sm:text-lg">Horario Administrativo</h3>
      <div class="flex justify-start lg:justify-start items-start space-x-2 sm:space-x-3">
        <svg
          class="mt-[4px]"
          width="15"
          height="15"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00016 4V8H5.3335"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <p class="text-white font-medium text-xs sm:text-base">
          <span [innerHTML]="site.footer.administrativeHours"></span>
        </p>
      </div>
    </div>

    <!-- Guardia General -->
    <div class="space-y-3 order-4">
      <h3 class="font-medium text-sm sm:text-lg">Guardia General las 24hs</h3>
      <div class="flex justify-center lg:justify-start items-start space-x-1 sm:space-x-3">
        <svg width="20" height="20" fill="white" class="flex-shrink-0 mt-[2px]">
          <path
            d="M12.7502 13.1041C13.032 13.1041 13.3022 12.9921 13.5015 12.7929C13.7007 12.5936 13.8127 12.3234 13.8127 12.0416C13.8127 11.7598 13.7007 11.4895 13.5015 11.2903C13.3022 11.091 13.032 10.9791 12.7502 10.9791C12.4684 10.9791 12.1981 11.091 11.9989 11.2903C11.7996 11.4895 11.6877 11.7598 11.6877 12.0416C11.6877 12.3234 11.7996 12.5936 11.9989 12.7929C12.1981 12.9921 12.4684 13.1041 12.7502 13.1041ZM13.8127 6.72909H12.0418V8.49992H15.201L13.8127 6.72909ZM4.25016 13.1041C4.53196 13.1041 4.80221 12.9921 5.00146 12.7929C5.20072 12.5936 5.31266 12.3234 5.31266 12.0416C5.31266 11.7598 5.20072 11.4895 5.00146 11.2903C4.80221 11.091 4.53196 10.9791 4.25016 10.9791C3.96837 10.9791 3.69812 11.091 3.49886 11.2903C3.2996 11.4895 3.18766 11.7598 3.18766 12.0416C3.18766 12.3234 3.2996 12.5936 3.49886 12.7929C3.69812 12.9921 3.96837 13.1041 4.25016 13.1041ZM14.1668 5.66659L16.2918 8.49992V12.0416H14.8752C14.8752 12.6052 14.6513 13.1457 14.2528 13.5442C13.8543 13.9427 13.3137 14.1666 12.7502 14.1666C12.1866 14.1666 11.6461 13.9427 11.2476 13.5442C10.849 13.1457 10.6252 12.6052 10.6252 12.0416H6.37516C6.37516 12.6052 6.15128 13.1457 5.75277 13.5442C5.35425 13.9427 4.81375 14.1666 4.25016 14.1666C3.68658 14.1666 3.14608 13.9427 2.74756 13.5442C2.34905 13.1457 2.12516 12.6052 2.12516 12.0416H0.708496V4.24992C0.708496 3.46367 1.33891 2.83325 2.12516 2.83325H12.0418V5.66659H14.1668ZM5.66683 4.24992V6.37492H3.54183V7.79159H5.66683V9.91659H7.0835V7.79159H9.2085V6.37492H7.0835V4.24992H5.66683Z"
            fill="white"
          />
        </svg>
        <p class="text-sm sm:text-base">
          <span [innerHTML]="site.footer.emergencyText"></span>
        </p>
      </div>
    </div>
  </div>

  <!-- Parte inferior gris -->
  <div
    class="hero px-4 py-4 grid [grid-template-columns:repeat(3,80px)] md:[grid-template-columns:repeat(9,80px)] gap-6 sm:gap-12 md:gap-0 place-items-center flex justify-center lg:justify-center items-center"
  >
    <img
      src="assets/images/logos/logo-red-amr.svg"
      alt="logo RED AMR ASOCIACION MEDICA DE ROSARIO"
      (click)="goRedAMR()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-amr.svg"
      alt="Logo ASOCIACION MEDICA DE ROSARIO"
      (click)="goAMR()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-mutual-arm.svg"
      alt="Logo La Mutual de AMR"
      (click)="goLaMutual()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-aliare-white.svg"
      alt="Logo Sanatorio Aliare"
      (click)="goAliare()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-armg.svg"
      alt="Logo amrgestion Asociacion Medica de Rosario"
      (click)="goAMR()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-ampar.svg"
      alt="Logo AMPAR"
      (click)="goAMPAR()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-amr-salud.svg"
      alt="Logo AMR SALUD MEDICA PRIVADA"
      (click)="goARMSalud()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-cedyca.svg"
      alt="Logo cedyca Centro de Diagnostico y Cirugia Ambulatoria"
      (click)="goCedyca()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
    <img
      src="assets/images/logos/logo-hospital-espanol.svg"
      alt="Logo Espanol HOSPITAL"
      (click)="goEspanol()"
      class="transition-transform duration-300 ease-in-out cursor-pointer hover:scale-105"
    />
  </div>

  <div class="bg-[var(--color-text-medium)] border-t border-white/10 py-4">
    <div
      class="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 px-4"
    >
      <button
        type="button"
        class="group flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-all duration-200"
        (click)="openTermsAndConditions()"
      >
        <span class="underline underline-offset-4 decoration-white/40 group-hover:decoration-white">
          Términos y Condiciones
        </span>
      </button>

      <div class="hidden sm:block h-4 w-px bg-white/20"></div>

      <button
        type="button"
        class="group flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-all duration-200"
        (click)="openPrivacyPolicy()"
      >
        <span class="underline underline-offset-4 decoration-white/40 group-hover:decoration-white">
          Políticas de Privacidad
        </span>
      </button>
    </div>
  </div>
</footer>
